import * as React from 'react';
import {Col, Container, Row} from 'reactstrap';
import StockForm from './stock-form';
import fileDownload from 'js-file-download';
import MiranaServiceClient from '../../../middleware/mirana-client';
import {lazyInject, TYPES} from '../../../utils/inversify-config';
import StockTable from './stock-table';
import * as moment from 'moment';
import {error, success} from '../../../utils/notification-actions';
import {connect} from 'react-redux';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import {getFileName} from '../../../utils/utils';

interface StockState {
    stockList: mirana.IUIStock[];
    fechaCarga?: string;
}

class Stocks extends React.PureComponent<ReduxProps, StockState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props, state) {
        super(props, state);

        this.state = {
            stockList: [],
        };

        this.handleFiltrar = this.handleFiltrar.bind(this);
        this.handleGenerarExcel = this.handleGenerarExcel.bind(this);
    };

    public async handleFiltrar(values) {
        const fechaCarga = moment(values.fecha).format('DD/MM/YYYY');
        try {
            const response = await this.apiClient.filtrarStock(fechaCarga);
            this.setState({
                stockList: response.stocks ? response.stocks : [],
                fechaCarga
            });

            this.props.dispatch(success('Notificación', `Registros encontrados: ${this.state.stockList.length}`));
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error interno al filtrar stock'));
        }
    }

    public async handleGenerarExcel() {
        const {fechaCarga} = this.state;
        if (fechaCarga) {
            const response = await this.apiClient.descargarStock(fechaCarga);
            fileDownload(response.data, getFileName(response));
        }
    }

    public render() {
        return (
            <Container>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Stock Gloria</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <StockForm onSubmit={this.handleFiltrar}/>
                    </Col>
                    <Col md={9}>
                        <StockTable handleGenerarExcel={this.handleGenerarExcel}
                                    stockList={this.state.stockList}
                                    fechaCarga={this.state.fechaCarga}/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default connect()(Stocks);



// WEBPACK FOOTER //
// ./src/components/pages/stock/stock.tsx